import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostBinding,
} from '@angular/core';
import * as moment from 'moment';
import {
  IMigration,
  IAccountMigration,
  MigrationState,
} from '../../models/IMigrations';

@Component({
  selector: 'app-migrations-accounts-table',
  templateUrl: './migrations-accounts-table.component.html',
  styleUrls: ['./migrations-accounts-table.component.scss'],
})
export class MigrationsAccountsTableComponent implements OnInit {
  @Input() migrations: IAccountMigration[];
  @Input() searchQuery = '';
  @Input() stateFilter: string[];
  @Input() fixedHeader = true;
  @Input() showAccountId = true;
  @Input() showLogButtons = true;
  @Input() isLoadingAccounts = false;
  @HostBinding('class.disabled') @Input() disabled = false;
  @Output() openMigrationModal = new EventEmitter<IMigration>();
  @Output() getMigrationReport = new EventEmitter<IMigration>();

  MigrationStates = MigrationState;

  constructor() {}

  ngOnInit() {}

  getLastSync(migration) {
    let lastSyncInUnix = null;
    if (migration && migration.order && migration.order.results) {
      const migrationResults = migration.order.results;
      if (
        migrationResults.optOutAll &&
        migrationResults.optOutAll.lastSyncTime
      ) {
        lastSyncInUnix = moment(
          migrationResults.optOutAll.lastSyncTime,
        ).valueOf();
      }
      if (
        migrationResults.subscribers &&
        migrationResults.subscribers.lastSyncTime
      ) {
        lastSyncInUnix =
          lastSyncInUnix >
          moment(migrationResults.subscribers.lastSyncTime).valueOf()
            ? lastSyncInUnix
            : moment(migrationResults.subscribers.lastSyncTime).valueOf();
      }
    }
    return lastSyncInUnix;
  }

  getMigrationStateClass(state: any) {
    switch (state) {
      case MigrationState.Failed:
        return 'danger';
      case MigrationState.Success:
        return 'success';
      case MigrationState.Pending:
        return 'warning';
      case MigrationState.Running:
        return 'primary';
      case MigrationState.Submitted:
        return 'primary';
      case MigrationState.Paused:
        return 'dark';
      default:
        return '';
    }
  }
}
